import { useEffect, useState } from "react";
import { Sparkles, Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { VERSION_LOG } from "@/lib/version";
import { useLanguage } from "@/context/LanguageContext";

const SEEN_KEY = "apptrack_whatsnew_seen";

export default function WhatsNew() {
    const { tr } = useLanguage();
    const [open, setOpen] = useState(false);
    const rel = VERSION_LOG[0];

    useEffect(() => {
        if (localStorage.getItem(SEEN_KEY) !== rel.v) setOpen(true);
    }, [rel.v]);

    const dismiss = () => {
        localStorage.setItem(SEEN_KEY, rel.v);
        setOpen(false);
    };

    return (
        <Dialog open={open} onOpenChange={(v) => (v ? setOpen(true) : dismiss())}>
            <DialogContent className="max-w-lg" data-testid="whats-new-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 font-heading text-navy dark:text-white">
                        <Sparkles className="w-4 h-4 text-[#00B4D8]" /> {tr("What's new in")} {rel.v}
                    </DialogTitle>
                </DialogHeader>
                <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">{rel.date}</div>
                <ul className="mt-3 space-y-2.5 max-h-72 overflow-y-auto pr-1">
                    {rel.items.map((item, i) => (
                        <li key={i} className="flex items-start gap-2.5 text-sm text-slate-600 dark:text-slate-300 leading-relaxed" data-testid={`whats-new-item-${i}`}>
                            <Check className="w-4 h-4 text-[#06D6A0] shrink-0 mt-0.5" /> {item}
                        </li>
                    ))}
                </ul>
                <button data-testid="whats-new-dismiss" onClick={dismiss} className="brand-btn w-full mt-4 px-4 py-2.5 rounded-[8px] text-sm font-bold">{tr("Got it")}</button>
            </DialogContent>
        </Dialog>
    );
}
